// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OutcomeFormCategoryInformationFragment = {
  __typename?: 'CategoryInformation';
  category: {
    __typename?: 'Category';
    id: string;
    goal: Types.GoalName;
    name: string;
    subCategoryTitle?: string | null;
    subCategoryList?: Array<{
      __typename?: 'SubCategory';
      id: string;
      name: string;
    }> | null;
  };
};

export type OutcomeFormCreateCompanyMutationVariables = Types.Exact<{
  input: Types.CompanyInput;
}>;

export type OutcomeFormCreateCompanyMutation = {
  __typename?: 'Mutation';
  createCompany: {
    __typename?: 'Company';
    id?: string | null;
    name: string;
    domain?: string | null;
    logoLink?: string | null;
  };
};

export type OutcomeFormCreateJobTitleMutationVariables = Types.Exact<{
  name: Types.Scalars['String']['input'];
}>;

export type OutcomeFormCreateJobTitleMutation = {
  __typename?: 'Mutation';
  createJobTitle: { __typename?: 'JobTitle'; id: string; name: string };
};

export type OutcomeFormCreateCoachingOutcomeMutationVariables = Types.Exact<{
  input: Types.CoachingOutcomeInput;
}>;

export type OutcomeFormCreateCoachingOutcomeMutation = {
  __typename?: 'Mutation';
  createCoachingOutcome: {
    __typename?: 'CoachingOutcome';
    id: string;
    outcome:
      | {
          __typename?: 'JobOfferInfo';
          company: {
            __typename?: 'Company';
            id?: string | null;
            name: string;
            logoLink?: string | null;
          };
          jobTitle?: {
            __typename?: 'JobTitle';
            id: string;
            name: string;
          } | null;
        }
      | {
          __typename?: 'SchoolAdmissionInfo';
          status?: Types.SchoolAdmissionStatus | null;
          school: {
            __typename?: 'School';
            id: string;
            name: string;
            logoLink?: string | null;
          };
        }
      | { __typename?: 'TestScoreV2'; score: number; testName: string };
  };
};

export const OutcomeFormCategoryInformationFragmentDoc = gql`
  fragment OutcomeForm_CategoryInformation on CategoryInformation {
    category {
      id
      goal
      name
      subCategoryList {
        id
        name
      }
      subCategoryTitle
    }
  }
`;
export const OutcomeFormCreateCompanyDocument = gql`
  mutation OutcomeForm_CreateCompany($input: CompanyInput!) {
    createCompany(input: $input) {
      id
      name
      domain
      logoLink
    }
  }
`;
export type OutcomeFormCreateCompanyMutationFn = Apollo.MutationFunction<
  OutcomeFormCreateCompanyMutation,
  OutcomeFormCreateCompanyMutationVariables
>;

/**
 * __useOutcomeFormCreateCompanyMutation__
 *
 * To run a mutation, you first call `useOutcomeFormCreateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOutcomeFormCreateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [outcomeFormCreateCompanyMutation, { data, loading, error }] = useOutcomeFormCreateCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOutcomeFormCreateCompanyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    OutcomeFormCreateCompanyMutation,
    OutcomeFormCreateCompanyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    OutcomeFormCreateCompanyMutation,
    OutcomeFormCreateCompanyMutationVariables
  >(OutcomeFormCreateCompanyDocument, options);
}
export type OutcomeFormCreateCompanyMutationHookResult = ReturnType<
  typeof useOutcomeFormCreateCompanyMutation
>;
export type OutcomeFormCreateCompanyMutationResult =
  Apollo.MutationResult<OutcomeFormCreateCompanyMutation>;
export type OutcomeFormCreateCompanyMutationOptions =
  Apollo.BaseMutationOptions<
    OutcomeFormCreateCompanyMutation,
    OutcomeFormCreateCompanyMutationVariables
  >;
export const OutcomeFormCreateJobTitleDocument = gql`
  mutation OutcomeForm_CreateJobTitle($name: String!) {
    createJobTitle(name: $name) {
      id
      name
    }
  }
`;
export type OutcomeFormCreateJobTitleMutationFn = Apollo.MutationFunction<
  OutcomeFormCreateJobTitleMutation,
  OutcomeFormCreateJobTitleMutationVariables
>;

/**
 * __useOutcomeFormCreateJobTitleMutation__
 *
 * To run a mutation, you first call `useOutcomeFormCreateJobTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOutcomeFormCreateJobTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [outcomeFormCreateJobTitleMutation, { data, loading, error }] = useOutcomeFormCreateJobTitleMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useOutcomeFormCreateJobTitleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    OutcomeFormCreateJobTitleMutation,
    OutcomeFormCreateJobTitleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    OutcomeFormCreateJobTitleMutation,
    OutcomeFormCreateJobTitleMutationVariables
  >(OutcomeFormCreateJobTitleDocument, options);
}
export type OutcomeFormCreateJobTitleMutationHookResult = ReturnType<
  typeof useOutcomeFormCreateJobTitleMutation
>;
export type OutcomeFormCreateJobTitleMutationResult =
  Apollo.MutationResult<OutcomeFormCreateJobTitleMutation>;
export type OutcomeFormCreateJobTitleMutationOptions =
  Apollo.BaseMutationOptions<
    OutcomeFormCreateJobTitleMutation,
    OutcomeFormCreateJobTitleMutationVariables
  >;
export const OutcomeFormCreateCoachingOutcomeDocument = gql`
  mutation OutcomeForm_CreateCoachingOutcome($input: CoachingOutcomeInput!) {
    createCoachingOutcome(input: $input) {
      id
      outcome {
        ... on SchoolAdmissionInfo {
          status
          school {
            id
            name
            logoLink
          }
        }
        ... on TestScoreV2 {
          score
          testName
        }
        ... on JobOfferInfo {
          company {
            id
            name
            logoLink
          }
          jobTitle {
            id
            name
          }
        }
      }
    }
  }
`;
export type OutcomeFormCreateCoachingOutcomeMutationFn =
  Apollo.MutationFunction<
    OutcomeFormCreateCoachingOutcomeMutation,
    OutcomeFormCreateCoachingOutcomeMutationVariables
  >;

/**
 * __useOutcomeFormCreateCoachingOutcomeMutation__
 *
 * To run a mutation, you first call `useOutcomeFormCreateCoachingOutcomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOutcomeFormCreateCoachingOutcomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [outcomeFormCreateCoachingOutcomeMutation, { data, loading, error }] = useOutcomeFormCreateCoachingOutcomeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOutcomeFormCreateCoachingOutcomeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    OutcomeFormCreateCoachingOutcomeMutation,
    OutcomeFormCreateCoachingOutcomeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    OutcomeFormCreateCoachingOutcomeMutation,
    OutcomeFormCreateCoachingOutcomeMutationVariables
  >(OutcomeFormCreateCoachingOutcomeDocument, options);
}
export type OutcomeFormCreateCoachingOutcomeMutationHookResult = ReturnType<
  typeof useOutcomeFormCreateCoachingOutcomeMutation
>;
export type OutcomeFormCreateCoachingOutcomeMutationResult =
  Apollo.MutationResult<OutcomeFormCreateCoachingOutcomeMutation>;
export type OutcomeFormCreateCoachingOutcomeMutationOptions =
  Apollo.BaseMutationOptions<
    OutcomeFormCreateCoachingOutcomeMutation,
    OutcomeFormCreateCoachingOutcomeMutationVariables
  >;
